import React from 'react'
import PropTypes from 'prop-types'

// Styled Elements
import {
  SubHeaderWrapper,
  SubHeaderNavList,
  SubHeaderNavListItem,
  SubHeaderNavListLink,
} from './DirectoryDetailsSubHeader.elements'

function DirectoryDetailsSubHeader(props) {
  // Hooks
  const { page, setPage } = props

  return (
    <SubHeaderWrapper>
      <SubHeaderNavList>
        <SubHeaderNavListItem>
          <SubHeaderNavListLink
            className={page === 0 && 'active'}
            onClick={() => {
              setPage(0)
            }}
          >
            Details
          </SubHeaderNavListLink>
        </SubHeaderNavListItem>

        <SubHeaderNavListItem>
          <SubHeaderNavListLink
            className={page === 1 && 'active'}
            onClick={() => {
              setPage(1)
            }}
          >
            Activity
          </SubHeaderNavListLink>
        </SubHeaderNavListItem>

        <SubHeaderNavListItem>
          <SubHeaderNavListLink
            className={page === 2 && 'active'}
            onClick={() => {
              setPage(2)
            }}
          >
            Risk and Verification
          </SubHeaderNavListLink>
        </SubHeaderNavListItem>
      </SubHeaderNavList>
    </SubHeaderWrapper>
  )
}

// Default Props
DirectoryDetailsSubHeader.defaultProps = {
  page: 0,
  setPage: () => {},
}

// Proptypes Validation
DirectoryDetailsSubHeader.propTypes = {
  page: PropTypes.number,
  setPage: PropTypes.func,
}
export default DirectoryDetailsSubHeader
